import * as types from './types';
import { SET_STICKY_MODE, SetStickyModeAction } from './types';

export const reloadHeader = (): types.ReloadHeaderAction => {
    return { type: types.RELOAD_HEADER };
};
export const reloadHeaderFinished = (): types.ReloadHeaderSuccessAction => {
    return { type: types.RELOAD_HEADER_SUCCESS };
};

export const setStickyMode = (isSticky: boolean): SetStickyModeAction => {
    return { type: SET_STICKY_MODE, payload: isSticky };
};

/* View Actions */
export const displayLocalContentAuthors = (): types.ActiveViewLocalContentAuthorsAction => {
    return { type: types.ACTIVE_VIEW_LOCAL_CONTENT_AUTHORS };
};
export const displayLocalContentCollection = (): types.ActiveViewLocalContentCollectionAction => {
    return { type: types.ACTIVE_VIEW_LOCAL_CONTENT_COLLECTION };
};
export const displayLocalContentProducts = (): types.ActiveViewLocalContentProductsAction => {
    return { type: types.ACTIVE_VIEW_LOCAL_CONTENT_PRODUCTS };
};
export const displayLocalContentProductDetails = (): types.ActiveViewLocalContentProductDetailsAction => {
    return { type: types.ACTIVE_VIEW_LOCAL_CONTENT_PRODUCT_DETAILS };
};
export const displayCatalogue = (): types.ActiveViewCatalogueAction => {
    return { type: types.ACTIVE_VIEW_CATALOGUE };
};
export const displayByProductType = (): types.ActiveViewByProductTypeAction => {
    return { type: types.ACTIVE_VIEW_BY_PRODUCT_TYPE };
};
export const displaySelectionlist = (): types.ActiveViewSelectionlistAction => {
    return { type: types.ACTIVE_VIEW_SELECTIONLIST };
};
export const displayCart = (): types.ActiveViewCartAction => {
    return { type: types.ACTIVE_VIEW_CART };
};
export const displayOrders = (): types.ActiveViewOrdersAction => {
    return { type: types.ACTIVE_VIEW_ORDERS };
};
export const displayOrdersDetail = (): types.ActiveViewOrdersDetailAction => {
    return { type: types.ACTIVE_VIEW_ORDERS_DETAIL };
};
export const displaySearch = (): types.ActiveViewSearchAction => {
    return { type: types.ACTIVE_VIEW_SEARCH };
};
export const displayProductDetail = (): types.ActiveViewProductDetailAction => {
    return { type: types.ACTIVE_VIEW_PRODUCT_DETAIL };
};
export const displayLibxProductDetail = (): types.ActiveViewLibxProductDetailAction => {
    return { type: types.ACTIVE_VIEW_LIBX_PRODUCT_DETAIL };
};
export const displayBundleDetail = (): types.ActiveViewBundleDetailAction => {
    return { type: types.ACTIVE_VIEW_BUNDLE_DETAIL };
};
export const displayBundleList = (): types.ActiveViewBundleListAction => {
    return { type: types.ACTIVE_VIEW_BUNDLE_LIST };
};
export const displayIncompleteSeries = (): types.ActiveViewIncompleteSeriesAction => {
    return { type: types.ACTIVE_VIEW_INCOMPLETE_SERIES };
};
export const displayNewlyAdded = (): types.ActiveViewNewlyAddedAction => {
    return { type: types.ACTIVE_VIEW_NEWLY_ADDED };
};
export const displayByGenre = (): types.ActiveViewByGenreAction => {
    return { type: types.ACTIVE_VIEW_BY_GENRE };
};
export const displayCompleteCollection = (): types.ActiveViewCompleteCollectionAction => {
    return { type: types.ACTIVE_VIEW_COMPLETE_COLLECTION };
};
export const displayCollectionSearch = (): types.ActiveViewCollectionSearchAction => {
    return { type: types.ACTIVE_VIEW_COLLECTION_SEARCH };
};
export const displayReserveDetail = (): types.ActiveViewReserveDetailAction => {
    return { type: types.ACTIVE_VIEW_RESERVE_DETAIL };
};
export const displayReserveList = (): types.ActiveViewReserveListAction => {
    return { type: types.ACTIVE_VIEW_RESERVE_LIST };
};
export const displayTermsAndConditions = (): types.ActiveViewTermsAndConditionsAction => {
    return { type: types.ACTIVE_VIEW_TERMS_AND_CONDITIONS };
};
export const displayLibxFeatured = (): types.ActiveViewLibxFeaturedAction => {
    return { type: types.ACTIVE_VIEW_LIBX_FEATURED };
};
export const displayLibxNewlyAdded = (): types.ActiveViewLibxNewlyAddedAction => {
    return { type: types.ACTIVE_VIEW_LIBX_NEWLY_ADDED };
};
export const displayLibxAllTitles = (): types.ActiveViewLibxAllTitlesAction => {
    return { type: types.ACTIVE_VIEW_LIBX_ALL_TITLES };
};
export const displayLibxGenres = (): types.ActiveViewLibxGenresAction => {
    return { type: types.ACTIVE_VIEW_LIBX_GENRES };
};
export const displayLibxRegions = (): types.ActiveViewLibxRegionsAction => {
    return { type: types.ACTIVE_VIEW_LIBX_REGIONS };
};
export const displayLote = (): types.ActiveViewLoteAction => {
    return { type: types.ACTIVE_VIEW_LOTE };
};
export const displayLoteFeatured = (): types.ActiveViewLoteFeaturedAction => {
    return { type: types.ACTIVE_VIEW_LOTE_FEATURED };
};
export const displayLoteNewlyAdded = (): types.ActiveViewLoteNewlyaddedAction => {
    return { type: types.ACTIVE_VIEW_LOTE_NEWLYADDED };
};
export const displayLoteGenres = (): types.ActiveViewLoteGenresAction => {
    return { type: types.ACTIVE_VIEW_LOTE_GENRES };
};
export const displayLoteProducts = (): types.ActiveViewLoteProductsAction => {
    return { type: types.ACTIVE_VIEW_LOTE_PRODUCTS };
};
export const displayLanguageLearning = (): types.ActiveViewLanguagelearningAction => {
    return { type: types.ACTIVE_VIEW_LANGUAGELEARNING };
};
export const displayLanguageLearningFeatured = (): types.ActiveViewLanguagelearningFeaturedAction => {
    return { type: types.ACTIVE_VIEW_LANGUAGELEARNING_FEATURED };
};
export const displayLanguageLearningNewlyAdded = (): types.ActiveViewLanguagelearningNewlyaddedAction => {
    return { type: types.ACTIVE_VIEW_LANGUAGELEARNING_NEWLYADDED };
};
export const displayLanguageLearningProducts = (): types.ActiveViewLanguagelearningProductsAction => {
    return { type: types.ACTIVE_VIEW_LANGUAGELEARNING_PRODUCTS };
};
export const displayForeignLanguageBundles = (): types.ActiveViewForeignlanguageBundlesAction => {
    return { type: types.ACTIVE_VIEW_FOREIGNLANGUAGE_BUNDLES };
};
export const displayCampaigns = (): types.ActiveViewCampaignsAction => {
    return { type: types.ACTIVE_VIEW_CAMPAIGNS };
};
export const displayMarketingCampaigns = (): types.ActiveViewMarketingCampaignsAction => {
    return { type: types.ACTIVE_VIEW_MARKETING_CAMPAIGNS };
};
export const displayLibraryManagedProductGroups = (): types.ActiveViewLibraryManagedProductGroupsAction => {
    return { type: types.ACTIVE_VIEW_LIBRARY_MANAGED_PRODUCT_GROUPS };
};
export const displayLibraryManagedProductGroup = (): types.ActiveViewLibraryManagedProductGroupAction => {
    return { type: types.ACTIVE_VIEW_LIBRARY_MANAGED_PRODUCT_GROUP };
};
